import $ from 'jquery';

window.addEventListener('px-ready',function(){
    $('.px-scrollable-slider.has-dotnav').each(function(){
        var sliderID = $(this).attr('slider-id');
        $(this).find('.scroll-slide').each(function(){
            var slideid = $(this).attr('slide-id');
            if(!slideid){
                slideid = 'id-'+Math.floor(Math.random() * Math.floor(99999999999))
                $(this).attr('slide-id',slideid);
                $(this).attr('id',slideid);
                $('.uk-dotnav[slider-id="'+sliderID+'"]').append('<li><a href="#" slide-id="'+slideid+'" slider-id="'+sliderID+'"></a></li>')
            }
        })
    })
    $('.uk-dotnav').on('click','a,span',function(){
        var slideid = $(this).attr('slide-id');
        var sliderID = $(this).attr('slider-id');
        var posArray = $('.px-scrollable-slider.has-dotnav .scroll-slide[slide-id="'+slideid+'"]').offset();
        var scrollPos = $('.px-scrollable-slider.has-dotnav[slider-id="'+sliderID+'"]').scrollLeft();
        $('.px-scrollable-slider.has-dotnav[slider-id="'+sliderID+'"]').animate({
            scrollLeft: scrollPos+posArray.left-20
            
        },500)
        return false;
    })
    $('.px-scrollable-slider.has-dotnav').on('scroll',function(){
        $('.uk-dotnav li').removeClass('uk-active')
        $(this).attr('active',0);
        var slider = $(this);
        var scrollLoc = $(this).scrollLeft;
        var sliderID = $(this).attr('slider-id');
        $(this).find('.scroll-slide').each(function(){
            var thisoffset = $(this).offset();
            if(thisoffset.left>0 && slider.attr('active') == 0){
                var slideID = $(this).attr('slide-id');
                $('[slide-id="'+slideID+'"][slider-id="'+sliderID+'"]').parent().addClass('uk-active')
                slider.attr('active',1);
            }
        })
    }).trigger('scroll');
})